import { gql } from '@apollo/client'

export const Query = gql`
  query Venue($companyId: ID!, $filters: VenueFilters) {
    venues(companyId: $companyId, filters: $filters, first: 1) {
      nodes {
        id
        address
        name
        notes
        map {
          url
        }
      }
      pageInfo { startCursor endCursor hasNextPage hasPreviousPage }
    }
  }
`
